class QuotasResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource: ng.resource.IResourceService,
        configService
    ) {
        const apiUrl = `${configService.contentApi.url}/v1`;

        return (headers = {}) => $resource(
            `${apiUrl}/organizations/:id/quotas/sales/counters-by-year`,
            {
                id: "@id",
                yearType: "@yearType"
            },
            {
                get: {
                    method: "GET",
                    headers
                },
                put: {
                    method: "PUT",
                    url: `${apiUrl}/quotas/sales/:yearType`,
                    headers
                }
            }
        );
    }
}

angular
    .module("thor.core.quotas.resource", [])
    .factory("quotasResource", QuotasResource);
